import React from 'react';
import {Container} from 'flux/utils';

import SessionStore from 'stores/SessionStore';
import HttpService from 'service/HttpService';

import {Redirect} from 'react-router-dom';

class LogoutContainer extends React.Component {
	static getStores() {
		return [SessionStore];
	}

	static calculateState(prevState) {
		let newState = {
				session: SessionStore.getCurrentSession()
			};
		return newState;
	}

	componentDidMount() {
		HttpService.logout();
	}

	render() {
		let currentSession = this.state.session;
		
		if(currentSession !== null) {
			return null;
		}

		return <Redirect to="/" push />
	}
}


export default Container.create(LogoutContainer);


// WEBPACK FOOTER //
// ./src/containers/LogoutContainer.js